const PERMISSION_KEY= "personalize:nebula_transactions";
const PAGE_URL = {
    NEBULA_TRANSACTIONS_PAGE: "/admin/personalize/nebula-transactions"
}

export {PERMISSION_KEY, PAGE_URL}

